/* hi-markt · Planung als PDF-DATEI (Betreiber 2026-09-26: „was, wenn der Kunde die Planung als PDF
   speichern will?" → ein Knopf, der die Datei direkt herunterlaedt).

   Bis dahin ging es nur ueber den Druckdialog: Zusammenfassung → „Planung als PDF" → „Drucken / als PDF
   sichern" → im Dialog „Als PDF speichern" waehlen. Am iPhone steckt das hinter „Teilen → In Dateien
   sichern". Jetzt entsteht die Datei im Browser — aus DEMSELBEN Beleg (HMPlanerBeleg.html), nicht aus
   einer zweiten Bauroutine: der Beleg wird unsichtbar in A4-Breite gesetzt, Abschnitt fuer Abschnitt auf
   Seiten verteilt (nie mitten durch eine Zeichnung, eine zu lange Tabelle bricht zwischen zwei Zeilen),
   jede Seite mit html2canvas als Bild gerechnet und in ein schlichtes PDF geschrieben. Die PDF-Datei
   schreibt diese Datei selbst (Bilder + Seitenzahl) — eine PDF-Bibliothek waere doppelt so gross.

   html2canvas 1.4.1 kommt erst beim Klick, fest in der Version und mit Pruefsumme (SRI).
   Der Druckweg bleibt fuer alle, die drucken wollen.

   Aufruf: HMPlanerPdf.herunterladen(html, dateiname, fortschritt) → Promise */
(function (w) {
  'use strict';
  var H2C = 'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js';
  var H2C_SRI = 'sha256-6H5VB5QyLldKH9oMFUmjxw2uWpPZETQXpCkBaDjquMs=';
  var MM = 96 / 25.4;                               /* CSS-Pixel je mm */
  var RAND = 14, SEITE_B = 210, SEITE_H = 297;       /* mm, wie @page im Beleg */
  var INHALT_B = SEITE_B - 2 * RAND, INHALT_H = SEITE_H - 2 * RAND - 6;   /* 6 mm fuer die Seitenzahl */
  var SKALA = 2;                                     /* Bildpunkte je CSS-Pixel */

  var laedt = null;
  function html2canvasLaden() {
    if (w.html2canvas) return Promise.resolve(w.html2canvas);
    if (laedt) return laedt;
    laedt = new Promise(function (fertig, schief) {
      var s = document.createElement('script');
      s.src = H2C; s.integrity = H2C_SRI; s.crossOrigin = 'anonymous'; s.async = true;
      s.onload = function () { if (w.html2canvas) fertig(w.html2canvas); else { laedt = null; schief(new Error('html2canvas fehlt')); } };
      s.onerror = function () { laedt = null; schief(new Error('html2canvas nicht ladbar')); };
      document.head.appendChild(s);
    });
    return laedt;
  }

  /* Den Beleg unsichtbar in Inhaltsbreite setzen; zusaetzlich: kein Bildschirm-Polster, kein Scrollen
     in Abschnitten (das gilt nur am Bildschirm). */
  function setzen(html) {
    return new Promise(function (fertig, schief) {
      var f = document.createElement('iframe');
      var b = Math.round(INHALT_B * MM);
      f.setAttribute('aria-hidden', 'true');
      f.tabIndex = -1;
      f.style.cssText = 'position:fixed;left:-10000px;top:0;width:' + b + 'px;height:1200px;border:0;opacity:0;pointer-events:none';
      /* DIESELBEN SCHRIFTEN wie die Seite: html2canvas zeichnet im Fenster der Seite (dort ist IBM Plex Sans
         geladen), gesetzt wird aber im Rahmen — ohne die @font-face-Regeln nahm er die Ersatzschrift, und
         jedes Wort stand an der Stelle der Ersatzschrift, gezeichnet in der echten: Luecken vor Punkt und
         Komma („eingeben .", gesehen 2026-09-26). */
      var schriften = [];
      Array.prototype.forEach.call(document.styleSheets, function (sh) {
        var regeln; try { regeln = sh.cssRules; } catch (e) { return; }
        Array.prototype.forEach.call(regeln || [], function (r) { if (r.type === 5) schriften.push(r.cssText); });
      });
      var extra = '<style>' + schriften.join('') + 'body{padding:0!important;margin:0!important}.sec{overflow:visible!important}</style>';
      f.srcdoc = html.replace('</head>', extra + '</head>');
      var fertigGeladen = false;
      f.onload = function () {
        if (fertigGeladen) return; fertigGeladen = true;
        var d = f.contentDocument;
        var bilder = Array.prototype.slice.call(d.images).map(function (im) {
          return im.complete ? null : new Promise(function (ok) { im.onload = im.onerror = ok; });
        }).filter(Boolean);
        Promise.all([d.fonts && d.fonts.ready ? d.fonts.ready : null].concat(bilder)).then(function () {
          /* GROSSBUCHSTABEN IM TEXT statt per CSS: html2canvas 1.4.1 wandelt `text-transform:uppercase`
             selbst um und zaehlt dann die Zeichen des umgewandelten Texts — aus „Serienmaße" wird
             „SERIENMASSE", ein Zeichen mehr, und das Zeichnen bricht ab („offset 11 is larger than the
             node's length (10)", gemessen 2026-09-26). Gleiche Optik, keine Umwandlung mehr. */
          Array.prototype.forEach.call(d.body.querySelectorAll('*'), function (el) {
            if (d.defaultView.getComputedStyle(el).textTransform !== 'uppercase') return;
            Array.prototype.forEach.call(el.childNodes, function (n) { if (n.nodeType === 3) n.data = n.data.toUpperCase(); });
            el.style.textTransform = 'none';
          });
          /* Breitere Tabellen als der Satzspiegel (Bestellliste mit Preisspalte, Schrift ohne IBM Plex Mono)
             liefen rechts aus dem Bild — der Druckdialog verkleinert dann, ein Ausschnitt schneidet ab
             („€269,9" ohne letzte Ziffer, gesehen 2026-09-26). Also so breit setzen, wie der Inhalt ist; das
             PDF bringt die Seite wieder auf 182 mm. */
          var sw = Math.ceil(d.documentElement.scrollWidth);
          if (sw > f.clientWidth + 1) f.style.width = (sw + 8) + 'px';
          f.style.height = Math.ceil(d.documentElement.scrollHeight) + 'px';
          setTimeout(function () { fertig(f); }, 50);
        });
      };
      setTimeout(function () { if (!fertigGeladen) schief(new Error('Beleg laedt nicht')); }, 20000);
      document.body.appendChild(f);
    });
  }

  /* SEITENPLAN aus Bloecken: Kopf, jeder Abschnitt, Fuss. Ein Block, der nicht mehr passt, beginnt eine neue
     Seite, `.seite` immer. Ist ein Block hoeher als eine ganze Seite, wird er zwischen Tabellenzeilen,
     Wertepaaren oder Hinweisen geteilt. Ergebnis je Seite: Stuecke { b: Blocknummer, von, bis } in
     blockeigenen CSS-Pixeln und `y`: wo das Stueck auf der Seite beginnt. Gezeichnet wird spaeter JEDER
     BLOCK FUER SICH — ein Ausschnitt aus dem ganzen Beleg lief auf spaeteren Seiten um bis zu 36 px
     gegen die Planung (html2canvas setzt seine Kopie etwas anders), Seite 5 zeigte unten schon die
     naechste Ueberschrift (gemessen 2026-09-26). Innerhalb eines Blocks bleibt so jede Abweichung im Block. */
  function seitenPlan(d, breite) {
    var H = INHALT_H * MM * (breite / (INHALT_B * MM));
    var box = function (el) { return el.getBoundingClientRect(); };
    var els = [];
    var kopf = d.querySelector('.hd'), fuss = d.querySelector('.ft');
    if (kopf) els.push(kopf);
    Array.prototype.forEach.call(d.querySelectorAll('main > *'), function (el) { els.push(el); });
    if (fuss) els.push(fuss);
    var bloecke = els.map(function (el) {
      var r = box(el), st = d.defaultView.getComputedStyle(el);
      var schnitte = Array.prototype.map.call(el.querySelectorAll('tr, .kv, .msg, figure, .hinw, .note, .warn, p'), function (x) {
        return box(x).bottom - r.top;
      }).filter(function (v) { return v > 0 && v < r.height; }).sort(function (a, b) { return a - b; });
      return { el: el, top: r.top, h: r.height, mt: parseFloat(st.marginTop) || 0, seite: el.classList.contains('seite'), schnitte: schnitte };
    });
    var seiten = [], seite = null;
    var neueSeite = function () { seite = { stuecke: [], hoehe: 0 }; seiten.push(seite); };
    bloecke.forEach(function (bl, i) {
      var abstand = i ? Math.max(0, bl.top - (bloecke[i - 1].top + bloecke[i - 1].h)) : 0;
      if (!seite || bl.seite) neueSeite();
      else if (seite.hoehe + abstand + bl.h > H && seite.stuecke.length) neueSeite();
      var y = seite.stuecke.length ? seite.hoehe + abstand : 0, von = 0;
      /* passt der Rest nicht: teilen */
      while (y + (bl.h - von) > H) {
        var grenze = von + (H - y), schnitt = 0;
        bl.schnitte.forEach(function (sv) { if (sv > von + 40 && sv <= grenze) schnitt = sv; });
        if (!schnitt) schnitt = grenze;
        seite.stuecke.push({ b: i, von: von, bis: schnitt, y: y });
        seite.hoehe = y + (schnitt - von);
        von = schnitt; neueSeite(); y = 0;
      }
      seite.stuecke.push({ b: i, von: von, bis: bl.h, y: y });
      seite.hoehe = y + (bl.h - von);
    });
    return { bloecke: bloecke, seiten: seiten.filter(function (x) { return x.stuecke.length; }) };
  }

  /* ---------- Ein schlichtes PDF: je Seite ein JPEG, unten die Seitenzahl ---------- */

  function bytesAusText(s) { var a = new Uint8Array(s.length); for (var i = 0; i < s.length; i++) a[i] = s.charCodeAt(i) & 0xff; return a; }
  function pdfAus(seiten, hinter) {
    var pt = 72 / 25.4, W = SEITE_B * pt, Hs = SEITE_H * pt;
    var teile = [], versatz = [], laenge = 0;
    var schreibe = function (x) { var b = typeof x === 'string' ? bytesAusText(x) : x; teile.push(b); laenge += b.length; };
    var n = seiten.length, objNr = 3 + 3 * n;           /* hoechste Nummer: 1 Katalog, 2 Seitenbaum, 3 Schrift, je Seite: Seite, Bild, Inhalt */
    var obj = function (nr) { versatz[nr] = laenge; schreibe(nr + ' 0 obj\n'); };
    schreibe('%PDF-1.4\n%\xe2\xe3\xcf\xd3\n');
    obj(1); schreibe('<< /Type /Catalog /Pages 2 0 R >>\nendobj\n');
    var kinder = [];
    for (var i = 0; i < n; i++) kinder.push((4 + 3 * i) + ' 0 R');
    obj(2); schreibe('<< /Type /Pages /Kids [' + kinder.join(' ') + '] /Count ' + n + ' >>\nendobj\n');
    obj(3); schreibe('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>\nendobj\n');
    var f3 = function (x) { return (Math.round(x * 1000) / 1000).toString(); };
    seiten.forEach(function (s, k) {
      var pNr = 4 + 3 * k, bNr = pNr + 1, cNr = pNr + 2;
      var bw = INHALT_B * pt, bh = bw * s.h / s.w, x = RAND * pt, y = Hs - RAND * pt - bh;
      var bg = hinter ? f3(hinter[0] / 255) + ' ' + f3(hinter[1] / 255) + ' ' + f3(hinter[2] / 255) + ' rg 0 0 ' + f3(W) + ' ' + f3(Hs) + ' re f\n' : '';
      var zahl = 'Seite ' + (k + 1) + ' von ' + n;
      var inhalt = 'q\n' + bg + f3(bw) + ' 0 0 ' + f3(bh) + ' ' + f3(x) + ' ' + f3(y) + ' cm /Im' + k + ' Do\nQ\n'
        + 'BT /F1 7.5 Tf 0.45 0.45 0.45 rg ' + f3(W - RAND * pt - zahl.length * 3.7) + ' ' + f3(RAND * pt * 0.55) + ' Td (' + zahl + ') Tj ET\n';
      obj(pNr); schreibe('<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + f3(W) + ' ' + f3(Hs) + '] /Resources << /Font << /F1 3 0 R >> /XObject << /Im' + k + ' ' + bNr + ' 0 R >> >> /Contents ' + cNr + ' 0 R >>\nendobj\n');
      obj(bNr); schreibe('<< /Type /XObject /Subtype /Image /Width ' + s.pw + ' /Height ' + s.ph + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + s.jpeg.length + ' >>\nstream\n');
      schreibe(s.jpeg); schreibe('\nendstream\nendobj\n');
      obj(cNr); schreibe('<< /Length ' + inhalt.length + ' >>\nstream\n' + inhalt + 'endstream\nendobj\n');
    });
    /* Objekte 1 … 3+3n, dazu Nummer 0: /Size = 4+3n. */
    var groesse = objNr + 1, xref = laenge, zeilen = ['0000000000 65535 f \n'];
    for (var j = 1; j < groesse; j++) zeilen.push(('0000000000' + versatz[j]).slice(-10) + ' 00000 n \n');
    schreibe('xref\n0 ' + groesse + '\n' + zeilen.join('') + 'trailer\n<< /Size ' + groesse + ' /Root 1 0 R >>\nstartxref\n' + xref + '\n%%EOF\n');
    var alles = new Uint8Array(laenge), o = 0;
    teile.forEach(function (b) { alles.set(b, o); o += b.length; });
    return alles;
  }

  function jpegBytes(cv) {
    return new Promise(function (fertig, schief) {
      var aus = function (blob) {
        if (!blob) { schief(new Error('JPEG')); return; }
        var r = new FileReader();
        r.onload = function () { fertig(new Uint8Array(r.result)); };
        r.onerror = function () { schief(new Error('JPEG lesen')); };
        r.readAsArrayBuffer(blob);
      };
      if (cv.toBlob) cv.toBlob(aus, 'image/jpeg', 0.9);
      else {
        var d = atob(cv.toDataURL('image/jpeg', 0.9).split(',')[1]), a = new Uint8Array(d.length);
        for (var i = 0; i < d.length; i++) a[i] = d.charCodeAt(i);
        fertig(a);
      }
    });
  }

  function herunterladen(html, dateiname, fortschritt) {
    var sag = function (t) { if (typeof fortschritt === 'function') { try { fortschritt(t); } catch (e) { /* Seite */ } } };
    var rahmen = null;
    sag(0);
    return Promise.all([html2canvasLaden(), setzen(html)]).then(function (r) {
      var h2c = r[0]; rahmen = r[1];
      var d = rahmen.contentDocument, breite = rahmen.clientWidth || Math.round(INHALT_B * MM);
      var plan = seitenPlan(d, breite);
      var farbe = d.defaultView.getComputedStyle(d.body).backgroundColor;
      var m = /rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)/.exec(farbe || ''), hinter = m ? [+m[1], +m[2], +m[3]] : null;
      var bilder = [], seiten = [];
      var optionen = { scale: SKALA, useCORS: true, logging: false, backgroundColor: farbe || '#ffffff',
        windowWidth: breite, windowHeight: Math.ceil(d.documentElement.scrollHeight),
        /* Die Kopie erst zeichnen, wenn ihre Schriften geladen sind — sonst misst sie mit der Ersatzschrift. */
        onclone: function (kopie) {
          var f = kopie.fonts, laden = [];
          if (f && f.forEach) f.forEach(function (ff) { laden.push(ff.load().catch(function () { return null; })); });
          return Promise.all(laden).then(function () { return f && f.ready; });
        } };
      var block = function (i) {
        if (i >= plan.bloecke.length) return Promise.resolve();
        return h2c(plan.bloecke[i].el, optionen).then(function (cv) {
          bilder[i] = cv;
          sag(0.8 * (i + 1) / plan.bloecke.length);
          return block(i + 1);
        });
      };
      var eine = function (k) {
        if (k >= plan.seiten.length) return Promise.resolve();
        var sp = plan.seiten[k], W = Math.round(breite * SKALA), Hp = Math.max(1, Math.ceil(sp.hoehe * SKALA));
        var cv = document.createElement('canvas');
        cv.width = W; cv.height = Hp;
        var c = cv.getContext('2d');
        c.fillStyle = farbe || '#ffffff'; c.fillRect(0, 0, W, Hp);
        sp.stuecke.forEach(function (st) {
          var q = bilder[st.b];
          if (!q) return;
          var fy = q.height / Math.max(1, plan.bloecke[st.b].h);          /* Bildpunkte je CSS-Pixel im Blockbild */
          var sy = Math.round(st.von * fy), sh = Math.max(1, Math.min(q.height - sy, Math.round((st.bis - st.von) * fy)));
          c.drawImage(q, 0, sy, q.width, sh, 0, Math.round(st.y * SKALA), W, Math.round(sh * W / q.width));
        });
        return jpegBytes(cv).then(function (jp) {
          seiten.push({ w: breite, h: sp.hoehe, pw: W, ph: Hp, jpeg: jp });
          sag(0.8 + 0.2 * (k + 1) / plan.seiten.length);
          return eine(k + 1);
        });
      };
      return block(0).then(function () { return eine(0); }).then(function () {
        var pdf = pdfAus(seiten, hinter);
        var url = URL.createObjectURL(new Blob([pdf], { type: 'application/pdf' }));
        var a = document.createElement('a');
        a.href = url; a.download = dateiname || 'Kuechenplanung.pdf'; a.rel = 'noopener';
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
        return { seiten: seiten.length, bytes: pdf.length };
      });
    }).then(function (erg) {
      if (rahmen) rahmen.remove();
      return erg;
    }, function (e) {
      if (rahmen) rahmen.remove();
      throw e;
    });
  }

  /* Fuer Proben: die Seitenplanung eines Belegs, ohne etwas zu zeichnen. */
  function planAnsehen(html) {
    return setzen(html).then(function (f) {
      var d = f.contentDocument, breite = f.clientWidth, p = seitenPlan(d, breite);
      var erg = { breite: breite, seiten: p.seiten, bloecke: p.bloecke.map(function (b) {
        return [(b.el.querySelector('h2') || b.el).textContent.slice(0, 24), Math.round(b.top), Math.round(b.h)];
      }) };
      f.remove();
      return erg;
    });
  }

  w.HMPlanerPdf = { herunterladen: herunterladen, planAnsehen: planAnsehen };
})(window);
